import _ from 'lodash';
import { polyfill } from 'es6-promise'
polyfill()

import Vue from 'vue'

import Vuex from 'vuex'
import VueLocalStorage from 'vue-localstorage'
import { sync } from 'vuex-router-sync';

import App from '@/containers/App/App'
import router from '@/router'

import store from './store'

Vue.use(Vuex)
Vue.use(VueLocalStorage, {
	name: 'ls',
	bind: true
})

sync(store, router);

Vue.set(Vue.prototype, '_', _);

/* eslint-disable no-new */
new Vue({
	el: '#app',
	store,
	router,
	template: '<App/>',
	components: {
		App,
	}
})


// WEBPACK FOOTER //
// ./src/main.js